export default __webpack_public_path__ + "static/git-baa3cde9e684d812c86d70d9f49b4f06.png";